module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhead2-e61b2e7209612cd169cc2de0e9d7f6d1.jpg";